import {Line} from "react-chartjs-2";

const ClientMeasurementsChart = ({data}) => {

  let chartData = {
    labels: data.map(a => a.formattedDate),
    datasets: [
      {
        label: 'Greutate',
        data: data.map(a => a.weight),
        tension: 0.4,
      },
      {
        label: 'Talie',
        data: data.map(a => a.waist),
        tension: 0.4,
      },
      {
        label: 'Bust',
        data: data.map(a => a.bust),
        tension: 0.4,
      },
      {
        label: 'Sold',
        data: data.map(a => a.hips),
        tension: 0.4,
      },
      {
        label: 'Maini',
        data: data.map(a => a.arms),
        tension: 0.4,
      },
      {
        label: 'Picioare',
        data: data.map(a => a.legs),
        tension: 0.4,
      }
    ]
  };

  const options = {
    scales: {
      y: {
        offset: true,
        ticks: {count: 5},
      },
      x: {
        offset: true
      }
    },
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        position: 'bottom'
      }
    },
  }

  return <Line
    type={'line'}
    data={chartData}
    options={options}
  />
}

export default ClientMeasurementsChart;